import React, {  Component, ReactNode } from "react";
import DefaultLayout, { DefaultLayoutProps } from "layouts/Default";
import { RouteComponentProps, withRouter } from "react-router";
import RouteURLs from "RouteURLs";
import "./index.scss";
import DashboardHeader from "components/DashboardHeader";
import { AuthenticatedUser } from "services/entities/auth";
import { CancellablePromise, WrappedCancellablePromise } from "util/promises";
import { isLoggedIn, loadUser } from "services/auth";
import UserWidget from "components/UserWidget";
import Footer from "components/Footer";

export enum DashboardTab {
  Overview,
  Designs,
  Bookings,
  Analytics,
}

interface DashboardLayoutState {
  user: AuthenticatedUser | null;
}

interface DashboardLayoutProps extends RouteComponentProps, DefaultLayoutProps {
  currentTab?: DashboardTab;
  tabChildren?: ReactNode;
}

class DashboardLayout extends Component<
  DashboardLayoutProps,
  DashboardLayoutState
> {
  state: DashboardLayoutState = {
    user: null,
  };

  private loadProfilePromise: CancellablePromise<AuthenticatedUser> | null =
    null;

  componentDidMount(): void {
    if (isLoggedIn()) {
      this.loadProfilePromise = new WrappedCancellablePromise(loadUser());
      this.loadProfilePromise.then(
        (user) => {
          this.loadProfilePromise = null;
          this.setState({ user: user });
        },
        () => {
          this.loadProfilePromise = null;
        }
      );
    }
  }

  componentWillUnmount(): void {
    if (this.loadProfilePromise != null) {
      this.loadProfilePromise.cancel();
      this.loadProfilePromise = null;
    }
  }


  renderHeader() {
    const user = this.state.user;
    const navItems = [
      { title: "Dashboard", route: RouteURLs.DASHBOARD },
      { title: "Designs", route: RouteURLs.DESIGN_LIST },
    ];
    return (
      <DashboardHeader navItems={navItems}>
        {user && <UserWidget user={user} />}
      </DashboardHeader>
    );
  }

  render() {
    const { children, className, ...props } = this.props;
    const fullClassName = `dashboard-layout ${className || ""}`;
    return (
      <DefaultLayout
        {...props}
        className={fullClassName}
        header={this.renderHeader()}
        footer={<Footer />}
      >
        {children}
      </DefaultLayout>
    );
  }
}

export default withRouter(DashboardLayout);
